







import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import PageTitle from '@/components/common/PageTitle.vue';

@Component({
  components: { AdminIframe, PageTitle },
})
export default class ProductAddBulkIframe extends Vue {
  private get remoteSrc() {
    const queryString = new URLSearchParams({ serviceType: 'PREMIUM' }).toString();
    return process.env.VUE_APP_ADMIN_REMOTE_URL + '/product/management/bulk/add?' + queryString;
  }
}
